import { root } from './start';

export const start = {
  ...root,
};
